import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Check, X, Trash2, Star, Lightbulb } from "lucide-react";

const STATUS_STYLES = {
  pending: "bg-yellow-500/20 text-yellow-500",
  approved: "bg-green-500/20 text-green-500",
  rejected: "bg-red-500/20 text-red-400",
};

const STATUS_LABELS = {
  pending: "Offen",
  approved: "Übernommen",
  rejected: "Abgelehnt",
};

const RequestsTab = ({ requests, onApprove, onReject, onDelete }) => (
  <Card className="bg-card border-border" data-testid="requests-tab">
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Lightbulb className="w-5 h-5 text-primary" /> Restaurant-Vorschläge
      </CardTitle>
      <CardDescription>
        Von Nutzern eingereichte Restaurants – mit einem Klick übernehmen. Der Nutzer wird per E-Mail benachrichtigt.
      </CardDescription>
    </CardHeader>
    <CardContent>
      {requests.length === 0 ? (
        <p className="text-muted-foreground text-sm" data-testid="requests-empty">Keine Vorschläge vorhanden</p>
      ) : (
        <div className="space-y-3">
          {requests.map((req) => (
            <div key={req.request_id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 border border-border rounded-lg" data-testid={`request-row-${req.request_id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium">{req.name}</span>
                  <span className="text-primary text-sm flex items-center">
                    {[...Array(req.stars || 1)].map((_, i) => <Star key={i} className="w-3 h-3 fill-primary" />)}
                  </span>
                  <span className={`px-2 py-0.5 text-xs rounded ${STATUS_STYLES[req.status] || ""}`} data-testid={`request-status-${req.request_id}`}>
                    {STATUS_LABELS[req.status] || req.status}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">
                  {req.location}, {req.country}{req.cuisine_type ? ` · ${req.cuisine_type}` : ""}
                </p>
                <p className="text-xs text-muted-foreground">
                  Vorgeschlagen von {req.submitter_name || "?"} ({req.submitter_email || "-"}) am {req.created_at ? new Date(req.created_at).toLocaleDateString("de-DE") : "-"}
                </p>
              </div>
              <div className="flex gap-2 shrink-0">
                {req.status === "pending" && (
                  <>
                    <Button size="sm" onClick={() => onApprove(req.request_id)} className="bg-green-600 hover:bg-green-700 text-white" data-testid={`approve-request-${req.request_id}`}>
                      <Check className="w-4 h-4 mr-1" /> Übernehmen
                    </Button>
                    <Button size="sm" variant="outline" onClick={() => onReject(req.request_id)} className="border-border text-red-400 hover:text-red-300" data-testid={`reject-request-${req.request_id}`}>
                      <X className="w-4 h-4 mr-1" /> Ablehnen
                    </Button>
                  </>
                )}
                <Button size="sm" variant="ghost" onClick={() => onDelete(req.request_id)} className="text-muted-foreground" data-testid={`delete-request-${req.request_id}`}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export default RequestsTab;
